

/*
Diese Funktion errechnet die notwenidige Laufzeit für eine Kreditsumme bei einem Zinssatz bezogen auf das Zahlungsintervall (Hier verrechnung bezeichnet) und die Annuitaet(z.B. Beispiel monatlich).
- Verrechnung spiegelt die im Ratenintervall enthaltenen Monate wieder. Kann also folgende Werte haben: 1 = Monatlich; 3 = Vierteljährlich; 6 = Halbjährlich; 12 = Jährlich
- Annuitaet ist der Betrag der pro Abrechnungsintervall gezahlt wird
- Zinssatz wird in Float angegeben. Beispiel für 2 Prozent -> 2.00
- Kreditsumme wird als Float angegeben. Beispiel für 1000 -> 1000.0
- Laufzeit_Periode gibt an ob die Laufzeit im Formular in Jahren oder Monaten angegeben ist und rechnet ggf. um
*/


window.formatNummer = function(n, c, d, t){
	var n = n,
    c = isNaN(c = Math.abs(c)) ? 2 : c,
    d = d == undefined ? "," : d,
    t = t == undefined ? "." : t,
    s = n < 0 ? "-" : "",
    i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
    j = (j = i.length) > 3 ? j % 3 : 0;
   return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
 }

 window.make_f = function(value, decimal) {
	 // console.log('MAKE_F -> ' + value);
 	v = value.split(".").join("");
 	v = v.replace(",",".");
  v = v.replace(/\s+/g, "");
 	float = parseFloat(v).toFixed(decimal);
 	// console.log('FLOAT:' + float + '|' + isNaN(float) );
 	return parseFloat(isNaN(float) ? 0.0 : float);
 }
